import { Component, AfterViewInit, ViewChild, ElementRef, OnDestroy, OnInit } from '@angular/core';
import * as L from 'leaflet';
import { TempoRealeService } from './tempo-reale.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewModalService } from 'app/generic/new-modal/new-modal.service';
import { MultiButtonRendererComponent } from 'app/generic/multi-button-renderer/multi-button-renderer.component';
import { SortController } from 'ag-grid-community';

@Component({
  selector: 'app-tempo-reale',
  templateUrl: './tempo-reale.component.html',
  styleUrls: ['./tempo-reale.component.scss']
})
export class TempoRealeComponent implements AfterViewInit, OnDestroy, OnInit {

  sensorMetaById: { [typeId: number]: { key: string, title: string, unit: string } } = {
    1: { key: 'barometri', title: 'Pressioni Barometriche rilevate (hPa)', unit: '(hPa)' },
    2: { key: 'ventoscalare', title: 'Metri al secondo rilevati (m/s)', unit: '(m/s)' },
    3: { key: 'ventoraffica', title: 'Metri al secondo rilevati (m/s)', unit: '(m/s)' },
    12: { key: 'idrometri', title: 'Dati rilevati rispetto allo "0" idrometrico', unit: '(m)' },
    13: { key: 'igrometri', title: 'Percentuali rilevate (%)', unit: '(%)' },
    24: { key: 'pluviometri', title: 'Istogramma cumulata oraria', unit: '(mm)' },
    25: { key: 'radiometri', title: 'Irradiazioni rilevate (W/m²)', unit: '(W/m²)' },
    31: { key: 'termometri', title: 'Temperatura oraria rilevata', unit: '(°C)' }
  };
  get tipoSensoreTitle(): string {
    return this.sensorMetaById[this.tipoSensoreToModal]?.title || 'Dati Sensore';
  }
  get tipoSensoreKey(): string {
    return this.sensorMetaById[this.tipoSensoreToModal]?.key || 'Dati Sensore';
  }

  sensorTypeMap: { [key: string]: number } = {
    barometri: 1,
    ventoscalare: 2,
    ventoraffica: 3,
    idrometri: 12,
    igrometri: 13,
    pluviometri: 24,
    radiometri: 25,
    termometri: 31
  };

  pdfDocumentUrl = '/assets/docs/sistema_monitoraggio_idrometeoclima_e_ondamare.pdf'; 
  excelDocumentUrl = '/assets/docs/TABELLA_STAZIONI.xlsx';
  nomeSensore: any;
  getFriendlyName(sensorKey: string): string {
    const normalizedKey = sensorKey?.toLowerCase().replace(/\s+/g, '');
    const friendlyMapping: { [key: string]: string } = {
      'barometri': 'Barometro',
      'barometro': 'Barometro',
      'ventoscalare': 'Velocità del Vento Media',
      'velocitaventomedia': 'Velocità del Vento Media',
      'ventoraffica': 'Velocità del Vento di Raffica',
      'velocitaventoraffica': 'Velocità del Vento di Raffica',
      'idrometri': 'Idrometro',
      'idrometro': 'Idrometro',
      'igrometri': 'Igrometro',
      'igrometro': 'Igrometro',
      'pluviometri': 'Pluviometro Puntuale',
      'pluviometro': 'Pluviometro Puntuale',
      'pluviometropuntuale': 'Pluviometro Puntuale',
      'radiometri': 'Radiometro',
      'radiometro': 'Radiometro',
      'termometri': 'Termometro',
      'termometro': 'Termometro'
    };
    return friendlyMapping[normalizedKey] || sensorKey;
  }

  get tipoSensoreFriendlyName(): string {
    return this.getFriendlyName(this.tipoSensoreKey);
  }

  customLocaleText = {
    noRowsToShow: 'Nessun dato disponibile',
    loadingOoo: 'Caricamento in corso...',
    page: 'Pagina',
    of: 'di',
    more: 'Altro',
    to: 'a',
    contains: 'Contiene',
  };

  ultimoAggiornamento: string | null = null;

  getUltimoAggiornamento(dati: any[]): string | null {
    if (!dati || dati.length === 0) return null;
    const rawTimestamp = dati[dati.length - 1]?.timestamp;
    if (!rawTimestamp) return null;
    const [datePart, timePart] = rawTimestamp.split(' ');
    const [year, month, day] = datePart.split('-');
    const oraMinuto = timePart.substring(0, 5);
    return `${day}/${month}/${year} ${oraMinuto}`;
  }

  isTabella = false;

  @ViewChild('theModalDetail') theModalDetail: ElementRef;
  @ViewChild('theModalSensori') theModalSensori: ElementRef;

  private map: L.Map | undefined;
  private markersLayer: L.LayerGroup = new L.LayerGroup([]);

  stationList: any[] = [];
  stationListSelect: any[] = []
  sensorList: any[] = [];
  selectedStationDetails: any = null;
  selectedStation: string = '';
  selectedSensorType: string = 'all';
  selectedSensorIdDetail: any;
  selectedSensorDetail: any;

  columnDefs: any[];
  defaultColDef: any;

  gridOptions: any;
  gridOptionsSensori: any
  dataTabella = [];
  sensoriToDettaglioTabella: any;
  stazioneSelezionata: any;

  private stationMarkers = new Map<string, L.Marker>();
  allStations: any[] = [];

  private customIcon = L.icon({
    iconUrl: './assets/img/spotlight-poi2-small.png',
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -35]
  });
  private selectedIcon = L.icon({
    iconUrl: './assets/img/spotlight-poi2-selected.png',
    iconSize: [32, 32],
    iconAnchor: [16, 16],
    popupAnchor: [0, -35]
  });

  private initialMapCenter: L.LatLngExpression = [40.7556, 14.9112];
  private initialMapZoom: number = 9;
  tipoSensoreToModal: any;
  idStazioneSelect: any = null;
  isLoadingSensorDetail = false;

  constructor(
    private tempoRealeService: TempoRealeService,
    private modalService: NgbModal,
    private newModal: NewModalService,
    public restService: TempoRealeService
  ) {
    this.columnDefs = [
      { headerName: 'ID Stazione', field: 'idStazione', sortable: true, filter: true },
      { headerName: 'Denominazione', field: 'denominazione', sortable: true, filter: true },
      { headerName: 'Comune', field: 'comune', sortable: true, filter: true },
      { headerName: 'Provincia', field: 'provincia', sortable: true, filter: true },
      { headerName: 'Bacino', field: 'bacino', sortable: true, filter: true },
      { headerName: 'Quota (m)', field: 'quota', sortable: true, filter: true },
      { headerName: 'Latitudine', field: 'latitudine', sortable: true, filter: true },
      { headerName: 'Longitudine', field: 'longitudine', sortable: true, filter: true }
    ];

    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true
    };
  }

  ngOnInit(): void {
    this.destroyMap();
    this.initMap();
  }

  ngAfterViewInit(): void {
    this.loadStations();
    this.setupAgSettings();
    this.caricaStazioniTabella();
    this.setupAgSettingsSensori();
    this.isTabella = true;
  }

  ngOnDestroy(): void {
    this.destroyMap();
  }

  openModal(modal) {
    this.modalService.open(modal, { backdrop: 'static', windowClass: "modalDettaglio" });
  }

  openSensorDetail(idSensore: number, tipoSensore: string, idTipoSensore: number) {
    if (this.isLoadingSensorDetail) {
      return;
    }
    this.isLoadingSensorDetail = true;
    this.selectedSensorIdDetail = idSensore;
    this.modalService.open(this.theModalDetail, { size: 'xl', scrollable: true });
    this.tempoRealeService.selectSensoreById(idSensore)
      .then(res => {
        const dati = res?.data || [];
        this.selectedSensorDetail = {
          dati: dati,
          id: idSensore,
          tipoId: idTipoSensore,
          nome: res?.sensoriBean?.nome || '',
          comune: res?.sensoriBean?.comune || ''
        };
        this.nomeSensore = this.selectedSensorDetail.nome;
        this.nomeSensore = this.selectedSensorDetail.comune;
        this.ultimoAggiornamento = this.getUltimoAggiornamento(dati);
        this.tipoSensoreToModal = idTipoSensore;
      })
      .catch(error => {
        this.modalService.dismissAll();
        this.newModal.open(
          "Attenzione",
          "Non è stato possibile evadere la richiesta, riprovare più tardi",
          "bg-danger"
        );
      })
      .finally(() => {
        this.isLoadingSensorDetail = false;
      });
  }

  closeSingleModal(modal) {
    modal.close('close');
  }

  private initMap(): void {
    if (this.map) {
      this.destroyMap();
    }
    this.map = L.map('map', {
      center: this.initialMapCenter,
      zoomSnap: 0.40,
      scrollWheelZoom: true
    });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: 'Protezione Civile Regione Campania'
    }).addTo(this.map);
    this.markersLayer.addTo(this.map);
  }

  private destroyMap(): void {
    if (this.map) {
      this.map.remove();
      this.map = undefined;
    }
  }

  private parseCoordinate(coordinate: string): number {
    if (!coordinate) return NaN;
    const normalized = coordinate.replace(',', '.');
    return parseFloat(normalized);
  }

  private loadStations(): void {
    this.tempoRealeService.selectAllStazioniByFilters().then(res => {
      const stazioni = res.listaStazioni || [];
      // const stazioniOrdinate = stazioni.sort((a: any, b: any) => {
      //   const denomA = a.denominazione || '';
      //   const denomB = b.denominazione || '';
      //   return denomA.localeCompare(denomB);
      // });
      // Mantiene l'ordine originale dal servizio REST
      this.stationList = stazioni;
      this.stationListSelect = stazioni;
      this.allStations = [...stazioni];
      this.renderMarkers();
    });
  }

  private renderMarkers(filteredStations: any[] = this.allStations, highlightId: string = ''): void {
    this.markersLayer.clearLayers();
    this.stationMarkers.clear();
    const bounds = new L.LatLngBounds([]);
    filteredStations.forEach(station => {
      const lat = this.parseCoordinate(station.latitudine);
      const lng = this.parseCoordinate(station.longitudine);
      if (!isNaN(lat) && !isNaN(lng)) {
        const icon = (station.idStazione === highlightId) ? this.selectedIcon : this.customIcon;
        const marker = L.marker([lat, lng], { icon })
        const tooltipContent = `
      <div style="text-align:center;">
        ${station.idSensore ? `<div>ID SENSORE: <span style="text-transform:uppercase"><strong>${station.idSensore}</strong></span></div>` : ''}
        ${station.comune ? `<div>COMUNE: <span class="uppercase"><strong>${station.comune.toUpperCase()} (${station.provincia.toUpperCase()})</strong></span></div>` : ''}
        ${station.denominazione ? `<div>NOME: <span class="uppercase"><strong>${station.denominazione.toUpperCase()}</strong></span></div>` : ''}
        ${station.quota && station.quota != "" ? `<div>QUOTA: <span class="uppercase"><strong>${station.quota} m.</strong></span></div>` : ''}
        ${station.bacino && station.bacino != "" && station.bacino !== null ? `<div>BACINO: <span class="uppercase"><strong> ${station.bacino} </strong></span></div>` : ''}
      </div>
    `;
        marker.bindTooltip(tooltipContent, {
          direction: 'top',
          offset: [0, -10],
          className: 'leaflet-tooltip'
        });
        marker.on('click', () => {
          this.onStationChange(station.idStazione, this.selectedSensorType === 'all' ? '*' : this.selectedSensorType);
        });
        this.stationMarkers.set(station.idStazione, marker);
        this.markersLayer.addLayer(marker);
        bounds.extend([lat, lng]);
      }
    });
    if (highlightId && this.stationMarkers.has(highlightId)) {
      const pos = this.stationMarkers.get(highlightId)?.getLatLng();
      if (pos) this.map?.setView(pos);
    } else {
      const featureGroup = L.featureGroup(Array.from(this.stationMarkers.values()));
      this.map?.fitBounds(featureGroup.getBounds(), { padding: L.point(24, 24) });
    }
  }

  public onStationChange(stationId: string, typeId: string): void {
    this.selectedStation = stationId;
    const tipoSensore = typeId !== '*' ? typeId : 'all';
    this.idStazioneSelect = stationId;
    this.evidenziaStazioneInTabella(stationId);
    if (!stationId) {
      this.sensorList = [];
      this.renderMarkers();
      return;
    }
    const fetcher = {
      all: () => this.tempoRealeService.listAllSensoriByIdStazione(stationId, '*'),
      igrometri: () => this.tempoRealeService.listAllSensoriByIdStazione(stationId, 13),
      termometri: () => this.tempoRealeService.listAllSensoriByIdStazione(stationId, 31),
      pluviometri: () => this.tempoRealeService.listAllSensoriByIdStazione(stationId, 24),
      ventoscalare: () => this.tempoRealeService.listAllSensoriByIdStazione(stationId, 2),
      ventoraffica: () => this.tempoRealeService.listAllSensoriByIdStazione(stationId, 3),
      barometri: () => this.tempoRealeService.listAllSensoriByIdStazione(stationId, 1),
      idrometri: () => this.tempoRealeService.listAllSensoriByIdStazione(stationId, 12),
      radiometri: () => this.tempoRealeService.listAllSensoriByIdStazione(stationId, 25)
    }[tipoSensore];
    if (fetcher) {
      fetcher().then(data => {
        // this.sensorList = (data || []).sort((a: any, b: any) => {
        //   const nomeA = a.nome || '';
        //   const nomeB = b.nome || '';
        //   return nomeA.localeCompare(nomeB);
        // });
        // Mantiene l'ordine originale dal servizio REST
        this.sensorList = data || [];
        this.renderMarkers(this.stationList, stationId);
      });
    }
  }

  public onSensorTypeFilterChange(): void {
    this.resetSelezioneTabella(); 
    this.idStazioneSelect = null;
    if (this.selectedSensorType === 'all') {
      this.sensorList = [];
      this.renderMarkers();
      // this.dataTabella = [...this.allStations].sort((a: any, b: any) => {
      //   const denomA = a.denominazione || '';
      //   const denomB = b.denominazione || '';
      //   return denomA.localeCompare(denomB);
      // });
      // Mantiene l'ordine originale dal servizio REST
      this.dataTabella = [...this.allStations];
      return;
    }
    this.sensorList = [];
    const sensorFetchers: { [key: string]: () => Promise<any> } = {
      igrometri: () => this.tempoRealeService.selectAllStazioniByIdTypo(this.sensorTypeMap.igrometri),
      termometri: () => this.tempoRealeService.selectAllStazioniByIdTypo(this.sensorTypeMap.termometri),
      pluviometri: () => this.tempoRealeService.selectAllStazioniByIdTypo(this.sensorTypeMap.pluviometri),
      ventoscalare: () => this.tempoRealeService.selectAllStazioniByIdTypo(this.sensorTypeMap.ventoscalare),
      ventoraffica: () => this.tempoRealeService.selectAllStazioniByIdTypo(this.sensorTypeMap.ventoraffica),
      barometri: () => this.tempoRealeService.selectAllStazioniByIdTypo(this.sensorTypeMap.barometri),
      idrometri: () => this.tempoRealeService.selectAllStazioniByIdTypo(this.sensorTypeMap.idrometri),
      radiometri: () => this.tempoRealeService.selectAllStazioniByIdTypo(this.sensorTypeMap.radiometri)
    };
    const fetchSensors = sensorFetchers[this.selectedSensorType];
    if (fetchSensors) {
      fetchSensors()
        .then((data) => {
          if (data && data.listaStazioni) {
            // const stazioniOrdinate = data.listaStazioni.sort((a: any, b: any) => {
            //   const denomA = a.denominazione || '';
            //   const denomB = b.denominazione || '';
            //   return denomA.localeCompare(denomB);
            // });
            // Mantiene l'ordine originale dal servizio REST
            this.stationList = data.listaStazioni;
            this.stationListSelect = data.listaStazioni;
            this.dataTabella = [...data.listaStazioni];
            this.renderMarkers(this.stationList);
          } else {
            this.sensorList = [];
            this.dataTabella = [];
            this.markersLayer.clearLayers();
          }
        })
        .catch((err) => {
          this.dataTabella = [];
        });
    }
  }

  public showAllMarkers(): void {
    this.sensorList = [];
    this.selectedSensorType = "all";
    this.loadStations();
    this.resetSelezioneTabella();
    // this.dataTabella = [...this.allStations].sort((a: any, b: any) => {
    //   const denomA = a.denominazione || '';
    //   const denomB = b.denominazione || '';
    //   return denomA.localeCompare(denomB);
    // });
    // Mantiene l'ordine originale dal servizio REST
    this.dataTabella = [...this.allStations];
  }

  closeSensorList() {
    this.sensorList = [];
  }

  public onStationFilterChange(): void {
    const stationId = this.idStazioneSelect;
    if (!stationId) {
      this.resetSelezioneTabella();
      return;
    }
    this.onStationChange(stationId, this.selectedSensorType === 'all' ? '*' : this.selectedSensorType);
  }

  private evidenziaStazioneInTabella(stationId: string): void {
    setTimeout(() => {
      if (this.gridOptions?.api) {
        let found = false;
        this.gridOptions.api.forEachNode((node: any) => {
          if (node.data && node.data.idStazione === stationId) {
            node.setSelected(true);
            this.gridOptions.api.ensureIndexVisible(node.rowIndex, 'middle');
            found = true;
          } else {
            node.setSelected(false);
          }
        });
      }
    }, 300);
  }

  private resetSelezioneTabella(): void {
    if (this.gridOptions?.api) {
      this.gridOptions.api.deselectAll();
    }
    this.idStazioneSelect = null;
  }

  esportaCSVtoFile(idSensore: number, idTipoSensore: number) {
    this.restService
      .esportaCSV(idSensore, idTipoSensore)
      .then((res: Blob) => {
        if (res instanceof Blob) {
          const url = window.URL.createObjectURL(res);
          const a = document.createElement('a');
          a.href = url;
          a.download = `export_sensore_${idSensore}.csv`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          this.newModal.open("Errore", "Non è stato possibile evadere la richiesta, riprovare più tardi", "bg-danger");
        }
      })
      .catch((err) => {
        this.newModal.open("Errore", "Non è stato possibile evadere la richiesta, riprovare più tardi", "bg-danger");
      });
  }

  visualizzaTabella() {}

  caricaStazioniTabella(): void {
    this.tempoRealeService.selectAllStazioniByFilters().then((
      data) => {
      if (data && data.listaStazioni) {
        // this.dataTabella = data.listaStazioni.sort((a: any, b: any) =>
        //   a.denominazione.localeCompare(b.denominazione)
        // );
        // Mantiene l'ordine originale dal servizio REST
        this.dataTabella = data.listaStazioni;
      }
    })
      .catch((err) => {});
  }

  pageSizeOptions = [10, 25, 50, 100, 200];
  currentPageSize = 25;

  setupAgSettings() {
    let ref = this;
    ref.gridOptions = {
      pagination: true,
      paginationPageSize: this.currentPageSize,
      paginationPageSizeSelector: this.pageSizeOptions,
      paginationAutoPageSize: false,
      suppressPaginationPanel: false,
      onGridReady: (params: any) => {},
      onPaginationChanged: (event: any) => {
        const newPageSize = event.api.paginationGetPageSize();
        if (newPageSize !== this.currentPageSize) {
          this.currentPageSize = newPageSize;
        }
      },
      animateRows: true,
      enableCellTextSelection: true,
      rowHeight: 50,
      suppressMovableColumns: true,
      rowSelection: 'single',
      suppressRowClickSelection: false,
      onRowClicked: (event: any) => {
        if (event.data) {
          this.idStazioneSelect = event.data.idStazione;
          this.onStationFilterChange();
        }
      },
      defaultColDef: {
        editable: false,
        filter: true,
        sortable: true,
        flex: 1,
        minWidth: 100,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
        cellClass: 'fontClamp',
        headerClass: 'header-center',
        suppressMenu: true,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
        },
        filterParams: {
          suppressAndOrCondition: true,
        },
      },
      rowStyle: {
        background: '#fff',
        color: '#000'
      },
      localeText: {
        page: 'Pagina',
        of: 'di',
        to: 'a',
        more: 'Altri',
        next: 'Successiva',
        last: 'Ultima',
        first: 'Prima',
        previous: 'Precedente',
        pageSize: 'Dimensione pagina',
        pageSizeSelectorLabel: 'Righe per pagina:',
        loadingOoo: 'Caricamento...',
        noRowsToShow: 'Nessun dato disponibile',
        contains: 'Contiene',
        notContains: 'Non contiene',
        equals: 'Uguale a',
        notEqual: 'Diverso da',
        startsWith: 'Inizia con',
        endsWith: 'Finisce con',
        filterOoo: 'Filtra...',
        applyFilter: 'Applica filtro',
        resetFilter: 'Reset filtro',
        clearFilter: 'Pulisci filtro'
      },
      columnDefs: [
        {
          headerName: "Denominazione",
          field: "denominazione",
          wrapText: true,
          autoHeight: true,
          width: 250,
          cellStyle: {
            'white-space': 'normal',
            'text-align': 'center',
            'line-height': '1.4',
            'padding': '8px',
            'word-break': 'keep-all',
            'overflow-wrap': 'break-word',
            'hyphens': 'auto'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Latitudine",
          field: "latitudine",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: false,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Longitudine",
          field: "longitudine",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: false,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Comune",
          field: "comune",
          cellClass: 'wrap-text tabella1',
          filter: "agTextColumnFilter",
          floatingFilter: true,
          enableSorting: true,
          width: 250,
          cellStyle: {
            'white-space': 'normal',
            'text-align': 'center',
            'line-height': '1.4',
            'padding': '8px',
            'word-break': 'keep-all',
            'overflow-wrap': 'break-word',
            'hyphens': 'auto'
          },
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Provincia",
          field: "provincia",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          enableSorting: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Regione",
          field: "regione",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Quota",
          field: "quota",
          cellClass: 'wrap-text tabella1',
          cellStyle: {
            'text-align': 'center'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value !== null ? params.value : "-"
        },
        {
          headerName: "Bacino",
          field: "bacino",
          cellStyle: {
            'white-space': 'normal',
            'text-align': 'center',
            'line-height': '1.4',
            'padding': '8px',
            'word-break': 'keep-all',
            'overflow-wrap': 'break-word',
            'hyphens': 'auto'
          },
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Azioni",
          field: "buttons",
          cellRenderer: MultiButtonRendererComponent,
          filter: false,
          sortable: false,
          cellRendererParams: {
            value: [
              {
                label: 'Vedi Sensori',
                class: 'clamp-icon icon now-ui-icons ui-1_zoom-bold btn btn-primary pointer',
                action: (row: any) => {
                  this.stazioneSelezionata = row
                  this.findSensoriFromTabella(row.idStazione)
                }
              }
            ]
          }
        }
      ]
    }
  }

  changePageSize(newSize: number): void {
    this.currentPageSize = newSize;
    if (this.gridOptions?.api) {
      this.gridOptions.api.paginationSetPageSize(newSize);
    }
  }

  findSensoriFromTabella(stationId) {
    this.tempoRealeService.listAllSensoriByIdStazione(stationId, "*").then((
      data) => {
      if (data && data != null) {
        // this.sensoriToDettaglioTabella = data.sort((a: any, b: any) => {
        //   const nomeA = a.nome || '';
        //   const nomeB = b.nome || '';
        //   return nomeA.localeCompare(nomeB);
        // });
        // Mantiene l'ordine originale dal servizio REST
        this.sensoriToDettaglioTabella = data;
        this.modalService.open(this.theModalSensori, { backdrop: 'static', windowClass: "modalDettaglio" });
      }
    })
      .catch((err) => {});
  }

  setupAgSettingsSensori() {
    let ref = this;
    ref.gridOptionsSensori = {
      animateRows: true,
      pagination: true,
      paginationPageSize: 10,
      paginationPageSizeSelector: [5, 10, 25, 50],
      paginationAutoPageSize: false,
      suppressPaginationPanel: false,
      enableCellTextSelection: true,
      rowHeight: 50,
      suppressMovableColumns: true,
      defaultColDef: {
        editable: false,
        filter: true,
        sortable: true,
        flex: 1,
        minWidth: 100,
        cellStyle: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
        cellClass: 'fontClamp',
        headerClass: 'header-center',
        suppressMenu: true,
        floatingFilterComponentParams: {
          suppressFilterButton: true,
        },
        filterParams: {
          suppressAndOrCondition: true,
        },
      },
      rowStyle: {
        background: '#fff',
        color: '#000'
      },
      localeText: {
        ...this.customLocaleText,
        page: 'Pagina',
        of: 'di',
        to: 'a',
        more: 'Altri',
        next: 'Successiva',
        last: 'Ultima',
        first: 'Prima',
        previous: 'Precedente',
        loadingOoo: 'Caricamento...',
        noRowsToShow: 'Nessun dato disponibile'
      },
      columnDefs: [
        {
          headerName: "Denominazione",
          field: "nome",
          cellClass: 'wrap-text tabella1',
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        },
        {
          headerName: "Tipo Sensore",
          field: "tipoSensore",
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? this.getFriendlyName(params.value) : "-"
        },
        /* {
          headerName: "Valore Massimo",
          field: "valoreMassimo",
          filter: "agTextColumnFilter",
          floatingFilter: true,
          valueFormatter: (params: any) => params.value ? params.value : "-"
        }, */
        {
          headerName: "Azioni",
          field: "buttons",
          cellRenderer: MultiButtonRendererComponent,
          filter: false,
          sortable: false,
          cellRendererParams: {
            value: [
              {
                label: 'Vedi Sensori',
                class: 'clamp-icon icon now-ui-icons ui-1_zoom-bold btn btn-primary pointer',
                action: (row: any) => {
                  this.openSensorDetail(row.idSensore, row.tipoSensore, row.idTipoSensore)
                }
              }
            ]
          }
        }
      ]
    }
  }
  openPdfDocument(): void {
    const pdfUrlWithParams = `${this.pdfDocumentUrl}#&navpanes=0&scrollbar=0&view=FitH`;
    window.open(pdfUrlWithParams, 'PDF', 'left=20,top=20,width=800,height=700,resizable=1');
  }
  downloadExcelFile(): void {
    // Crea un link temporaneo per il download
    const link = document.createElement('a');
    link.href = this.excelDocumentUrl;
    link.download = 'TABELLA_STAZIONI.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

}
